import {
  Analytics,
  Awards,
  ConceptPlan,
  ContinuousImprovement,
  Creative,
  CrossPlatform,
  Custom,
  Delivery,
  DesigningForPatients,
  DesigningImpactfulBranding,
  EffectiveCommunication,
  EngagementTools,
  EngagingPatients,
  EventAudioVisual,
  FullyManaged,
  Gift,
  GreatContent,
  Guest,
  Impact,
  KolRehearsal,
  MaximiseReach,
  Merch,
  OnlinePlatform,
  PerfectVenue,
  Plan,
  PostPlan,
  Privacy,
  ProjectManagement,
  RelevantContent,
  Secure,
  ShareVideo,
  Sharing,
  Speaker,
  TeamBuilding,
  TechnicalInfrastructure,
  Timeline,
  Unified
} from './index';

const SVGMapper = {
  'analytics': Analytics,
  'awards': Awards,
  'concept-plan': ConceptPlan,
  'continuous-improvement': ContinuousImprovement,
  'creative': Creative,
  'cross-platform': CrossPlatform,
  'custom': Custom,
  'delivery': Delivery,
  'designing-for-patients': DesigningForPatients,
  'designing-impactful-branding': DesigningImpactfulBranding,
  'effective-communication': EffectiveCommunication,
  'engagement-tools': EngagementTools,
  'engaging-patients': EngagingPatients,
  'event-audio-visual': EventAudioVisual,
  'fully-managed': FullyManaged,
  'gift': Gift,
  'great-content': GreatContent,
  'guest': Guest,
  'impact': Impact,
  'kol-rehearsal': KolRehearsal,
  'maximise-reach': MaximiseReach,
  'merch': Merch,
  'online-platform': OnlinePlatform,
  'perfect-venue': PerfectVenue,
  'plan': Plan,
  'post-plan': PostPlan,
  'privacy': Privacy,
  'project-management': ProjectManagement,
  'relevant-content': RelevantContent,
  'secure': Secure,
  'share-video': ShareVideo,
  'sharing': Sharing,
  'speaker': Speaker,
  'team-building': TeamBuilding,
  'technical-infrastructure': TechnicalInfrastructure,
  'timeline': Timeline,
  'unified': Unified
};

export default SVGMapper;
